import { useEffect, useState } from 'react';
import { collection, doc, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';
const stores = new Map();
const EMPTY = { collections: [], offers: [], space: null, loading: true, error: '' };
// Share subscriptions across a Space's media panels and publishing controls.
export function useCreatorPublishing(spaceId) {
    const key = String(spaceId || '');
    const [value, setValue] = useState({ key, data: EMPTY });
    useEffect(() => {
        if (!key) { setValue({ key, data: { ...EMPTY, loading: false } }); return undefined; }
        let store = stores.get(key);
        if (!store) {
            store = { data: EMPTY, subscribers: new Set(), unsubscribes: [], ready: new Set() };
            stores.set(key, store);
            const update = patch => {
                store.data = { ...store.data, ...patch, loading: store.ready.size < 3 };
                store.subscribers.forEach(callback => callback(store.data));
            };
            const failure = source => { store.ready.add(source); update({ error: 'Could not load creator publishing data.' }); };
            store.unsubscribes = [
                onSnapshot(doc(db, 'users', key), snapshot => { store.ready.add('space'); update({ space: snapshot.exists() ? snapshot.data() : null }); }, () => failure('space')),
                onSnapshot(query(collection(db, 'nftCollections'), where('creatorUserId', '==', key)), snapshot => { store.ready.add('collections'); update({ collections: snapshot.docs.map(item => ({ id: item.id, ...item.data() })) }); }, () => failure('collections')),
                onSnapshot(query(collection(db, 'digitalAssetOffers'), where('spaceId', '==', key)), snapshot => { store.ready.add('offers'); update({ offers: snapshot.docs.map(item => ({ id: item.id, ...item.data() })) }); }, () => failure('offers')),
            ];
        }
        const callback = data => setValue({ key, data });
        store.subscribers.add(callback);
        callback(store.data);
        return () => {
            store.subscribers.delete(callback);
            if (!store.subscribers.size) { store.unsubscribes.forEach(unsubscribe => unsubscribe()); stores.delete(key); }
        };
    }, [key]);
    return value.key === key ? value.data : EMPTY;
}
